<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="mdi mdi-calendar-multiple"></i>&nbsp;Events</h4>
                                <h5 class="card-subtitle">Show all created and received events</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue collapse show">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="bg-light">
                                    <th class="border-0"><h6>Context</h6></th>
                                    <th class="border-0"><h6>Name</h6></th>
                                    <th class="border-0"><h6>Description</h6></th>
                                    <th class="border-0"><h6>Creator</h6></th>
                                    <th class="border-0"><h6>Counterparty</h6></th>
                                    <th class="border-0"><h6>Created At</h6></th>
                                    <th class="border-0"><h6>Actions</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(e, index) in events">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="m-r-10">
                                                <span class="btn-md btn-circle btn-outline-success" v-if="e.context === 'trade'">
                                                    <i class="fas fa-handshake"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-cyan" v-if="e.context === 'purchase'">
                                                    <i class="fas fa-cart-arrow-down"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-primary" v-if="e.context === 'sale'">
                                                    <i class="fas fa-credit-card"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-orange" v-if="e.context === 'invoice'">
                                                    <i class="fas fa-money-bill-alt"></i>
                                                </span>
                                                <span class="btn-md btn-circle btn-outline-tumblr" v-if="e.context === 'Partner'">
                                                <i class="fas fa-user-plus"></i>
                                            </span>
                                            </div>
                                            <div class="">
                                                <h6 class="m-b-0 font-16">{{e.context | capitalize}}</h6>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{e.name}}</td>
                                    <td data-toggle="tooltip" data-placement="top" :title="e.desc">{{e.desc | truncate(30, '.....')}}</td>
                                    <td>{{e.emitter.first_name}} {{e.emitter.last_name}}</td>
                                    <td>{{e.counterparty.first_name}} {{e.counterparty.last_name}}</td>
                                    <td>{{e.created_at | timestamp}}</td>
                                    <td>
                                        <a @click="toContext(e.id, e.visibility, e.context, e.context_props)" href="javascript:void(0)"><i class="fas fa-eye m-10"></i></a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Events",
        components: {Paginate},
        data() {
            return {
                pageCount: 1,
                pageNumber: 1,
                total: 0,
                events: []
            }
        },
        mounted() {
            this.init();
            this.$root.$on('refreshEvents', () => {
                this.init();
            })
        },
        methods: {
            async init() {
                await this.getAllEvents(1);
            },
            async getAllEvents(page) {
                let reply   = await this.$http.get(`notifications/all`, {
                    params: {
                        page: page,
                        perPage: 10
                    }
                });
                this.total  = reply.data.total;
                this.events = reply.data.events;
                this.setPageCount();
            },
            pageHandler(pageNum) {
                this.pageNumber = pageNum;
                this.getAllEvents(pageNum);

            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            toContext(eventid, visibility, context, context_props) {
                switch(context) {
                    case 'trade':
                        this.$router.push({name: "viewtrade", params: {tradeid: context_props.tradeid}});
                        this.$root.$emit('refreshTrade');
                        break;
                    case 'purchase':
                        this.$router.push({name: "viewpo", params: {poid: context_props.purchaseid}});
                        this.$root.$emit('refreshPo');
                        break;
                    case 'sale':
                        this.$router.push({name: "viewsale", params: {saleid: context_props.saleid}});
                        this.$root.$emit('refreshSo');
                        break;
                    case 'invoice':
                        this.$router.push({name: "viewinvoice", params: {invoiceid: context_props.invoiceid}});
                        this.$root.$emit('refreshInvoice');
                        break;
                    case 'Partner':
                        if(context_props.marketplace_id) {
                            this.$router.push({name: "alloffers"});
                        }else if(context_props.member_id){
                            this.$router.push({name: "partner-invitation", params: {memberid: context_props.member_id}});
                        }
                        break;

                }
            },
        }
    }
</script>

<style scoped>

</style>
